import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { AuthInitialState } from './auth.state';
import type { AuthTypes, UserPortal } from '@/common/types/auth.types';

const initialState: AuthTypes = AuthInitialState;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTH: (state, action: PayloadAction<string>) => {
      state.jwtToken = action.payload;
    },
    SET_ACCOUNT: (state, action: PayloadAction<{ userId: number; verification: UserPortal }>) => {
      state.userId = action.payload.userId;
      state.tokenVerification = action.payload.verification;
    },
    SET_INCIDENT_SETTINGS: (
      state,
      action: PayloadAction<{ gatheringId: string | null; viewingId: string | null }>
    ) => {
      state.incidentGatheringId = action.payload.gatheringId;
      state.incidentViewingId = action.payload.viewingId;
    },
    SET_ACTIVE_GROUP: (state, action: PayloadAction<number>) => {
      if (state.tokenVerification) {
        state.tokenVerification.pvActiveGroupID = action.payload;
      }
    },
    SET_ACTIVE_COUNTY: (state, action: PayloadAction<number>) => {
      state.activeCountyId = action.payload;
    },
  },
});

export const { SET_AUTH, SET_ACCOUNT, SET_INCIDENT_SETTINGS, SET_ACTIVE_GROUP, SET_ACTIVE_COUNTY } =
  authSlice.actions;

export default authSlice.reducer;
